<div class="th-menulevel">
  <div
    class="ir-btn ir-btn--big"
    *ngIf="showFoldersMenu"
    [ngClass]="isVisible('general') ? 'th-btn-action' : 'th-btn-menulevel'"
    (click)="showGroup($event, 'general')"
  >
    <i *ngIf="isVisible('general')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.module' | translate }}</span>
  </div>
  <div
    class="ir-btn ir-btn--big"
    *ngIf="!showFoldersMenu"
    [ngClass]="isVisible('general') ? 'th-btn-action' : 'th-btn-menulevel'"
    (click)="showGroup($event, 'general')"
  >
    <i *ngIf="isVisible('general')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.folder' | translate }}</span>
  </div>
  <div
    class="ir-btn ir-btn--big"
    [ngClass]="isVisible('edit') ? 'th-btn-action' : 'th-btn-menulevel'"
    (click)="showGroup($event, 'edit')"
  >
    <i *ngIf="isVisible('edit')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.edit' | translate }}</span>
  </div>
  <div
    class="ir-btn ir-btn--big"
    [ngClass]="isVisible('points') ? 'th-btn-action' : 'th-btn-menulevel'"
    (click)="showGroup($event, 'points')"
  >
    <i *ngIf="isVisible('points')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.points' | translate }}</span>
  </div>
  <div
    class="ir-btn ir-btn--big"
    *ngIf="showFoldersMenu"
    [ngClass]="isVisible('folders') ? 'th-btn-action' : 'th-btn-menulevel'"
    (click)="showGroup($event, 'folders')"
  >
    <i *ngIf="isVisible('folders')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.folders' | translate }}</span>
  </div>
  <div class="th-menulevel--area">
    <div class="th-menulevel--areacontent">
      <div *ngIf="isVisible('general')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(1)">
        <span>{{ 'menus.properties' | translate }}</span>
      </div>
      <div *ngIf="isVisible('points')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(2)">
        <span>{{ 'menus.add' | translate }} {{ 'menus.point' | translate }}</span>
      </div>
      <div *ngIf="isVisible('points')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(3)">
        <span>{{ 'menus.create' | translate }} {{ 'menus.point' | translate }}</span>
      </div>
      <div *ngIf="isVisible('points')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(8)">
        <span>{{ 'menus.order' | translate }} {{ 'menus.points' | translate }}</span>
      </div>

      <div *ngIf="isVisible('folders')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(4)">
        <span>{{ 'menus.create' | translate }} {{ 'menus.folder' | translate }}</span>
      </div>

      <div
        *ngIf="isVisible('edit')"
        class="ir-btn ir-btn--area th-btn-{{ anyFolders || anyPoints ? 'menusublevel' : 'disabled' }}"
        (click)="selectMenu(13)"
      >
        <span>{{ 'menus.copy' | translate }}</span>
      </div>
      <div
        *ngIf="isVisible('edit')"
        class="ir-btn ir-btn--area th-btn-{{ anyFolders || anyPoints ? 'menusublevel' : 'disabled' }}"
        (click)="selectMenu(6)"
      >
        <span>{{ 'menus.cut' | translate }}</span>
      </div>
      <div
        *ngIf="isVisible('points') && !isTemplate"
        class="ir-btn ir-btn--area th-btn-{{ anyFolders || anyPoints ? 'menusublevel' : 'disabled' }}"
        (click)="selectMenu(11)"
      >
        <span>{{ 'menus.mark-done' | translate }}</span>
      </div>
      <div
        *ngIf="isVisible('edit')"
        class="ir-btn ir-btn--area th-btn-{{ isPaste() ? 'menusublevel' : 'disabled' }}"
        (click)="selectMenu(7)"
      >
        <span>{{ 'menus.paste' | translate }}</span>
      </div>
      <div
        *ngIf="isVisible('edit') && !isInOffline"
        class="ir-btn ir-btn--area th-btn-{{ anyPoints || anyFolders ? 'remove' : 'disabled' }}"
        (click)="selectMenu(14)"
      >
        <span>{{ 'menus.delete' | translate }} {{ 'menus.selected' | translate }}</span>
      </div>
      <!--
      <div *ngIf="isVisible('general')" class="ir-btn ir-btn--area th-btn-remove" (click)="selectMenu(9)">
        <span>{{ 'menus.delete' | translate }}</span>
      </div>
      -->
      <div
        *ngIf="isVisible('general') && currentPerson?.isHost && isConnection"
        class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(12)"
      >
        <span>{{ 'menus.edit-json' | translate }}</span>
      </div>
    </div>
  </div>
</div>
